import { RiskStatus } from '@app/src/types/resourceExplorer'
import type { SustainabilityTopicProviderRisk, SustainabilityTopicRisk } from '@app/src/types/topicalRisk'

// TODO: Remove this when we have decided how to handle NotApplicable better in backend
export function processProviderRisk(
  providerRisk: SustainabilityTopicProviderRisk | null,
): SustainabilityTopicProviderRisk | null {
  if (!providerRisk) return null

  // Deep clone to avoid mutating the original data
  const processedRisk = structuredClone(providerRisk)

  processedRisk.sustainabilityAreaRisks?.forEach(areaRisk => {
    areaRisk.sustainabilityTopicRisks?.forEach(topicRisk => {
      // Using type assertion since backend can return 'ANotApplicable' which is not in the RiskStatus enum
      const isOperationNotApplicable = (topicRisk.operationRiskStatus as string) === 'ANotApplicable'
      const isIndustryNotApplicable = (topicRisk.industryRiskStatus as string) === 'ANotApplicable'
      const isHeadquarterNotApplicable = (topicRisk.headquarterRiskStatus as string) === 'ANotApplicable'
      const isAssessmentUndefined =
        topicRisk.assessmentLevel === undefined && topicRisk.assessmentSectionLevel === undefined

      if (isOperationNotApplicable && isIndustryNotApplicable && isHeadquarterNotApplicable && isAssessmentUndefined) {
        topicRisk.totalRiskStatus = RiskStatus.NotApplicable
      }
    })
  })

  return processedRisk
}

export function findTopicRisk(
  providerRisk: SustainabilityTopicProviderRisk | null | undefined,
  sustainabilityTopicId: number | undefined,
): SustainabilityTopicRisk | undefined {
  if (!providerRisk || sustainabilityTopicId === undefined) return undefined

  for (const areaRisk of providerRisk.sustainabilityAreaRisks ?? []) {
    const match = areaRisk.sustainabilityTopicRisks?.find(
      topicRisk => topicRisk.sustainabilityTopicId === sustainabilityTopicId,
    )
    if (match) return match
  }

  return undefined
}
